module.exports = __webpack_public_path__ + "static/media/ico-menu.c90c217f.svg";